import styled from 'styled-components'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'
import Calendar from 'presentation/shared/components/CalendarNew'

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 32px;
  z-index: 2;
`

export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  @media (max-width: 1350px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 840px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const InputCalendar = styled.div`
  position: relative;
`

export const HeadCountersWrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin: 40px 0 8px;

  @media (max-width: 1250px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 8px;
    margin: 32px 0 24px;
  }
`

export const CountersWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin: 16px 0;
`

export const AuthorizationProcessCountersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1250px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }
`

export const FinalizedCountersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 24px;

  @media (max-width: 1250px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  @media (max-width: 780px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
  }
`

export const SchedulingCountersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;

  @media (max-width: 1250px) {
    gap: 24px;
  }

  @media (max-width: 992px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (max-width: 780px) {
    gap: 16px;
  }
`

export const ActiveSearchCountersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (max-width: 800px) {
    gap: 16px;
  }
`

export const StyledCalendar = styled(Calendar)<{ show: boolean }>`
  position: absolute;
  top: 32px;
  left: 0;
  width: 300px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const StyledAccordion = styled(Accordion)`
  padding: 0 !important;
  margin: 0 !important;
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 !important;
  margin: 0 !important;

  .MuiAccordionSummary-content {
    margin: 0 !important;
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
  display: block !important;
  padding: 0 !important;
  margin: 0 !important;
`
export const CountersHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`
